import { SignIn } from "@clerk/clerk-react";
import { AuthLayout, ClerkNotConfiguredPlaceholder, clerkAppearance } from "../components/AuthLayout";
import { DevQuickSignIn } from "../components/dev/DevQuickSignIn";

const clerkPk = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

// Localhost-only convenience: skip the email + 424242 dance during dev.
// `DevQuickSignIn` self-hides outside DEV builds + non-localhost hosts.
//
// ⚠ THIS LIST PINS IDENTITIES THE PRODUCT CAN DESTROY. A reset invalidates it
// wholesale: the P6 reset (2026-08-09/10) deleted all six accounts that used to
// live here, and every button then answered "Couldn't find your account". Refresh
// it from ai-docs/login-credentials.md §C.0, which is the authoritative record of
// what exists in LOCAL-DEV — not §A.1, which is production and lists the same
// `+clerk_test` addresses for accounts that are still very much alive there.
//
// Deriving this list from live data was considered and REFUSED: this page renders
// pre-authentication, so it would need a user-listing endpoint callable with no
// token — turning the sign-in page into an account enumerator, which is worse
// than the staleness it would cure. The staleness at least announces itself.
// ⚠ Guarded so the ARRAY ITSELF is tree-shakeable, not just its consumer.
// Caught by this change's own acceptance test (2026-08-10): `DevQuickSignIn`'s
// body was already being eliminated from production builds — its
// `Lexiun-424242` constant is absent — but a bare module-level array literal
// SURVIVED, so every address here was shipping to production clients as dead
// data. Not a leak of anything secret (RFC-reserved `@example.com` addresses,
// documented as non-secret), and it was true of the six entries that preceded
// this one — but there is no reason to ship dev identities at all.
// `import.meta.env.DEV` is statically replaced at build time, so the false
// branch collapses and the literal goes with it.
const DEV_USERS = import.meta.env.DEV
  ? [{ label: "rita", identifier: "rita.souza+clerk_test@example.com" }]
  : [];

export function SignInPage() {
  return (
    <AuthLayout eapText="No account yet? Join the early access program →">
      <DevQuickSignIn users={DEV_USERS} />
      {clerkPk ? (
        <SignIn routing="path" path="/sign-in" appearance={clerkAppearance} />
      ) : (
        <ClerkNotConfiguredPlaceholder mode="sign-in" />
      )}
    </AuthLayout>
  );
}
